var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product_banner"},[_c('div',{staticClass:"banner_info"},[_c('h3',[_vm._v("解决方案")]),_c('p',[_vm._v("数字赋能 智造驱动 降本增效")])])])}]

export { render, staticRenderFns }